import {apiEnvironment} from '../smoothr-web-app-core/environments/apiEnvironment';

export const kampsCustomerGroup = 'kamps';
export const customerGroup = kampsCustomerGroup;

const supportEmail = {
	kamps: 'kamps@smoothr.de'
};
const firebaseConfig = {
	kamps: {
		apiKey: 'AIzaSyB1Y4wG6BoFE2hi8irI30ofKfscXoEPPDw',
		authDomain: 'prod-env-smoothr.firebaseapp.com',
		databaseURL: 'https://prod-env-smoothr.firebaseio.com',
		projectId: 'prod-env-smoothr',
		storageBucket: 'prod-env-smoothr.appspot.com',
		messagingSenderId: '640058019537',
		appId: '1:640058019537:web:3bf37aa627f37de9cbfff0',
		measurementId: 'G-0M174YC68T'
	}
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyAPOO3lxiEcXe0-BU1oe2cwRTLHBkcJNZo',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup,
	...apiEnvironment,
	countryList: ['de']
};
